import { z } from 'zod';

import {
  updateCurrentPageExpiredResult,
  updateCurrentPageNoDigestsResult,
  updateCurrentPagePartialResult,
  updateCurrentPageUnconfirmedResult,
  updateCurrentPageUpdatedResult,
} from './tool-result-copy';
import type { ClientToolDefinition } from './types';

const schema = z.object({ prompt: z.string() }).passthrough();

export const updateCurrentPageTool: ClientToolDefinition<typeof schema> = {
  schema,
  async run({ prompt }, { deps, emit }) {
    const { ok, digests, expectedCount, failureReason } =
      await deps.updateCurrentPage({ prompt }, emit);
    if (!ok) {
      if (failureReason === 'expired') {
        return updateCurrentPageExpiredResult;
      }
      return updateCurrentPageUnconfirmedResult;
    }
    if (digests.length === 0) {
      return updateCurrentPageNoDigestsResult;
    }
    if (expectedCount !== undefined && digests.length < expectedCount) {
      return updateCurrentPagePartialResult(expectedCount, digests);
    }
    return updateCurrentPageUpdatedResult(digests);
  },
};
